import React from "react";
import { Link } from "react-router-dom";
import { ListItem } from "@deere/ux.uxframe-react";
import { generateTitle } from '../shared/utils';
import { Box, Grid, Typography } from '@deere/fuel-react';
import WarningIcon from "@material-ui/icons/Warning";
import DoneIcon from "@material-ui/icons/Done";

export const RatingProgram = ({ ratingProgram }) => {
    const title = generateTitle(ratingProgram.functionalAreas, ratingProgram.subFunctionalAreas);
    return (
        <ListItem className="list-group-item mb-1" style={{ borderRadius: "0.25rem" }} key={ratingProgram.id}>
            <Grid container>
                <Grid item xs={12} md={8}>
                    <Link
                        to={{
                            pathname: `/rating-programs/edit-rating-program/${ratingProgram.id}`,
                        }}>
                        FY{ratingProgram.fiscalYear}, {title}
                    </Link>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Box display="flex" justifyContent="flex-end">
                        <Typography size="md" fontWeight="bold" component="p" display="inline">
                            Status &nbsp;
                        </Typography>
                        {ratingProgram.publishStatus !== "Y" && (
                            <WarningIcon fontSize="small" style={{ fill: "#fab64c", marginRight: "0.25rem" }} display="inline" />)}
                        {ratingProgram.publishStatus === "Y" && (
                            <DoneIcon fontSize="small" style={{ fill: "#367c2b" }} display="inline" />)}
                        <Typography size="md" fontWeight="regular" component="p" display="inline">
                            {ratingProgram.publishStatus === "Y" ? "Published" : "Not Yet Published"}
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </ListItem>
    );
}